//@flow
import BaseEntitySelectors from 'common/redux/selectors/BaseEntitySelectors';
import { createSelector } from 'reselect';

class OutletSelectors extends BaseEntitySelectors {
    constructor() {
        super('outlet');
    }
    getFilteredEntitesCount = createSelector([this.getEntities], entities => {
        return entities && entities.paginationInfo.total;
    });
}

export default new OutletSelectors();
